import { useTranslation } from 'react-i18next';

import { Button, Typography } from '@mui/material';

import type { TModalsContext } from '@/contexts/ModalsProvider/types';

import { SHRUNK_WIDTH as NAV_BAR_WIDTH } from '@/config/navBar';

import { GenericModal } from '@/components/modal/GenericModal';

export const FirstRunWelcome = ({ open, close }: TModalsContext) => {
  const { t } = useTranslation();
  const getStarted = () => {
    close('firstRun.welcome');
    open('stations.create', {
      onSuccess: () => {
        open('firstRun.success', {
          title: 'stationSetup.success.congratsFirst',
        });
      },
    });
  };

  return (
    <GenericModal
      sx={{
        left: NAV_BAR_WIDTH + 32,
        top: 48,
        width: 480,
        padding: 6,
        transform: 'none',
      }}
    >
      <Typography variant="h4" textAlign="center">
        {t('firstRun.welcome')}
      </Typography>

      <Typography marginY={6} color="textSecondary" whiteSpace="pre-line">
        {t('firstRun.overview')}
      </Typography>

      <Button onClick={getStarted} fullWidth>
        {t('firstRun.getStarted')}
      </Button>
    </GenericModal>
  );
};
